import Birthday from './components/Birthday';
import BodyPart from './components/BodyPart';
import Conclusion from './components/Conclusion';
import Content from './components/Content';
import Department from './components/Department';
import Device from './components/Device';
import Email from './components/Email';
import ExpiredDate from './components/ExpiredDate';
import FilterGroup from './components/FilterGroup';
import FormDatePicker from './templates/FormDatePicker';
import FormInput from './templates/FormInput';
import FormInputArea from './templates/FormInputArea';
import FormPassword from './templates/FormPassword';
import FormSelect from './templates/FormSelect';
import FormTagInput from './templates/FormTagInput';
import FormTextEditor from './templates/FormTextEditor';
import FormTimePicker from './templates/FormTimePicker';
import Gender from './components/Gender';
import InstitutionList from './components/InstitutionList';
import LayoutList from './components/LayoutList';
import LoadMore from './components/LoadMore';
import Modality from './components/Modality';
import Password from './components/Password';
import PasswordConfirm from './components/PasswordConfirm';
import Permissions from './components/Permissions';
import PhoneNumber from './components/PhoneNumber';
import ProcedureGroup from './components/ProcedureGroup';
import ProcedureList from './components/ProcedureList';
import ProcedureName from './components/ProcedureName';
import Roles from './components/Roles';
import Status from './components/Status';
import Technician from './components/Technician';
import TemplateType from './components/TemplateType';
import Upload from './components/Upload';
import Username from './components/Username';
import DatePickerMobile from './templates/FormDatePickerMobile';
// import FormSelectInfinity from './templates/FormSelectInfinity';

interface FormItemSubComponents {
  Birthday: typeof Birthday;
  BodyPart: typeof BodyPart;
  Conclusion: typeof Conclusion;
  Content: typeof Content;
  DatePicker: typeof FormDatePicker;
  DatePickerMobile: typeof DatePickerMobile;
  Department: typeof Department;
  Device: typeof Device;
  Email: typeof Email;
  ExpiredDate: typeof ExpiredDate;
  FilterGroup: typeof FilterGroup;
  Gender: typeof Gender;
  Input: typeof FormInput;
  InputArea: typeof FormInputArea;
  InputPassword: typeof FormPassword;
  InstitutionList: typeof InstitutionList;
  LayoutList: typeof LayoutList;
  LoadMore: typeof LoadMore;
  Modality: typeof Modality;
  Password: typeof Password;
  PasswordConfirm: typeof PasswordConfirm;
  Permissions: typeof Permissions;
  PhoneNumber: typeof PhoneNumber;
  ProcedureGroup: typeof ProcedureGroup;
  ProcedureList: typeof ProcedureList;
  ProcedureName: typeof ProcedureName;
  Roles: typeof Roles;
  Select: typeof FormSelect;
  // SelectInfinity: typeof FormSelectInfinity;
  Status: typeof Status;
  TagInput: typeof FormTagInput;
  Technician: typeof Technician;
  TemplateType: typeof TemplateType;
  TextEditor: typeof FormTextEditor;
  TimePicker: typeof FormTimePicker;
  Upload: typeof Upload;
  Username: typeof Username;
}

const FormItem: React.FC<any> & FormItemSubComponents = () => {
  return <div>FormItem</div>;
};

FormItem.Birthday = Birthday;
FormItem.Email = Email;

FormItem.ExpiredDate = ExpiredDate;
FormItem.Gender = Gender;

FormItem.InstitutionList = InstitutionList;
FormItem.Modality = Modality;
FormItem.ProcedureGroup = ProcedureGroup;
FormItem.ProcedureName = ProcedureName;

FormItem.Password = Password;
FormItem.PasswordConfirm = PasswordConfirm;
FormItem.Permissions = Permissions;
FormItem.PhoneNumber = PhoneNumber;

FormItem.Roles = Roles;
FormItem.Status = Status;

FormItem.Conclusion = Conclusion;
FormItem.Content = Content;
FormItem.LayoutList = LayoutList;
FormItem.ProcedureList = ProcedureList;
FormItem.TemplateType = TemplateType;
FormItem.TimePicker = FormTimePicker;
FormItem.Upload = Upload;
FormItem.Username = Username;

// FormItem.SelectInfinity = FormSelectInfinity;
FormItem.BodyPart = BodyPart;
FormItem.DatePicker = FormDatePicker;
FormItem.DatePickerMobile = DatePickerMobile;
FormItem.Department = Department;
FormItem.Device = Device;
FormItem.FilterGroup = FilterGroup;
FormItem.Input = FormInput;
FormItem.InputArea = FormInputArea;
FormItem.InputPassword = FormPassword;
FormItem.LoadMore = LoadMore;
FormItem.Select = FormSelect;
FormItem.TagInput = FormTagInput;
FormItem.Technician = Technician;
FormItem.TextEditor = FormTextEditor;

export default FormItem;
